import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import CalendarList from "../../components/layout/CalendarList";
import { postNotification } from "../../components/utilities/Notifications";
import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import { getData } from "../../components/utilities/UtilityFunctions";

export default function CircuitCalendar() {
  let { leagueId } = useParams();
  const [loading, setLoading] = useState(false);
  const [circuit, setCircuit] = useState(null);

  useEffect(() => {
    const check = async () => {
      setLoading(true);
      try {
        if (leagueId) {
          var apiCircuit = await getData(`/leagues/${leagueId}`, {
            queryStringParameters: {
              "expand[]": ["gameSystem", "gameStore", "gameStoreUser"],
            },
          });
          setCircuit(apiCircuit);
        } else {
          setCircuit({});
        }
      } catch (err) {
        postNotification("error", err);
      }
      setLoading(false);
    };
    check();
  }, [leagueId]);

  return (
    <>
      {Boolean(loading) && <ModalLoadingFull />}
      {circuit && <CalendarList circuit={circuit} />}
    </>
  );
}
